import { DateRangeFilter } from '@/contexts/table-context';
import { formatCalendarDateParam, lastDaysRange } from '@/utils/date-util';

/**
 * The date params the campaigns endpoints read. With local date ranges a
 * "Last N days" preset goes out as the browser's N calendar days and no
 * `date_range`: the API counts `date_range` from today at each opening, which
 * can be a different window from the one the picker shows. The days come from
 * the preset on each request, so a saved URL's old `from` / `to` is not sent.
 * @param dateRange - The applied filter. eg { preset: '7', startDate: '2026-10-08', endDate: '2026-10-14' }
 * @param localDays - Whether the account counts metrics in calendar days at each opening.
 * @returns The preset, start date and end date to send. eg { preset: undefined, startDate: '2026-10-08', endDate: '2026-10-14' }
 */
export function campaignsDateParams(
  dateRange: DateRangeFilter | undefined,
  localDays: boolean,
): DateRangeFilter {
  const preset = dateRange?.preset;
  if (!localDays || !preset || preset === 'lifetime') {
    return {
      preset,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
    };
  }

  const { from, to } = lastDaysRange(Number(preset), true);
  return {
    preset: undefined,
    startDate: formatCalendarDateParam(from),
    endDate: formatCalendarDateParam(to),
  };
}
